<template>
    <div id="breadcrumb" class="ui segment" :class="{'red': is_out_of_date, 'green': !is_out_of_date}">
        <transition name="slide-fade" mode="out-in">
            <div v-if="is_breadcrumb">
                <div class="ui breadcrumb">
                    <!-- This page is out of date, please click here to refresh. -->
                    <!-- 此頁面的資料已非最新，請點此重新整理 -->
                    <span class="out_of_date_alert" :class="{'active': is_out_of_date}"
                        :data-tooltip="$t('ui.notifications.help.this_page_is_out_of_date_please_click_here_to_refresh')"
                        :data-position="'top left'">
                        <i class="icon refresh pointer" :class="{'red': is_out_of_date}" @clicks="refresh()" style="cursor: pointer;"></i>
                    </span>
                    <!-- <h4 class="out_of_date_alert" v-if="is_out_of_date">This page is out of date, please click red icon to refresh.</h4> -->
                    {{ $t('ui.page_titles.current_page') }}：

                    <router-link :to="{name: 'provider_index'}" class="section">
                        {{ $t('ui.page_titles.index') }}
                    </router-link>

                    <span v-for="(breadcrumb, index) in $route.meta.breadcrumb">
                        <i class="right chevron icon divider" v-if="breadcrumb"></i>
                        <span v-if="index == $route.meta.breadcrumb.length - 1">
                            <div class="section">
                                {{ $t('ui.page_titles.' + breadcrumb) }}
                            </div>
                        </span>
                        <span v-else>
                            <router-link
                                :to="{name: breadcrumb}"
                                class="active section">
                                {{ $t('ui.page_titles.' + breadcrumb) }}
                            </router-link>
                        </span>
                    </span>
                </div>

                <div class="ui right floated actions" v-if="$route.meta.btns">
                    <router-link
                        v-for="(btn, index) in $route.meta.btns"
                        v-if="($route.meta.btns.length == 1) || (style.width > 767)"
                        class="ui icon button"
                        style="margin: -9px 6px;"
                        :class="[btn_class(btn, index)]"
                        :key="btn"
                        :to="{name: btn}">
                        <i v-if="btn.includes('new_')" class="plus icon"
                            :style="style.width > 500 ? {}:{margin: 0}"></i>
                        <span v-if="style.width > 500">
                            {{ $t('ui.page_titles.'+btn) }}
                        </span>
                    </router-link>

                    <div v-if="!(($route.meta.btns.length == 1) || (style.width > 767))"
                        @click="is_breadcrumb = false"
                        style="margin: -9px 6px;"
                        class="ui icon positive basic button">
                        <i class="ellipsis horizontal icon"></i>
                    </div>
                </div>
                <div class="clear"></div>
            </div>
        </transition>
        <transition name="slide-fade" mode="out-in">
            <div v-if="!is_breadcrumb" style="margin: -9px 0px;">
                <div @click="is_breadcrumb = true"
                    :style="(style.width < 381)?{padding: '9px'}:{}"
                    class="ui icon positive basic button">
                    <i class="arrow left icon"></i>
                </div>
                <div class="ui right floated actions" v-if="$route.meta.btns">
                    <router-link
                        v-for="(btn, index) in $route.meta.btns"
                        class="ui icon button"
                        :class="btn_class(btn, index)"
                        :style="(style.width < 381)?{padding: '9px'}:{}"
                        :key="btn"
                        :to="{name: btn}">
                        <i v-if="btn.includes('new_')" class="plus icon"
                            :style="style.width > 390 ? {}:{margin: 0}"></i>
                        <span>
                            {{ $t('ui.page_titles.'+btn) }}
                        </span>
                    </router-link>
                </div>
                <div class="clear"></div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            is_out_of_date: false,
            is_breadcrumb: true,
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
    },
    mounted() {
        this.detect_out_of_date();
    },
    watch: {
        '$route.meta.btns' (val) {
            if (!val) {
                this.is_breadcrumb = true
            }
        },
        '$route'(to, from) {
            this.is_breadcrumb = true
        },
    },
    methods: {
        detect_out_of_date() {
            this.$cable.subscriptions.create(
                {
                    channel: 'OutOfDateChannel',
                },
                {
                received: (data) => {
                    if (
                        this.$store.state.instance_identity != data.exclude_instance &&
                        _.findLast(this.$store.state.breadcrumbs, (breadcrumb) => breadcrumb == data.scope)
                    ) {
                        this.is_out_of_date = true
                    }
                }
            })
        },
        btn_class(name = "", index) {
            try {
                var class_name = ((index <= 1) && name.includes('new_')) ? 'positive' : 'blue'
                if (!class_name) {
                    switch (index) {
                        case 2:
                            throw 'orange'
                            break
                        default:
                            throw 'grey'
                    }
                } else {
                    throw class_name
                }
            } catch (e) {
                return e
            }
            return 'grey'
        },
        refresh() {
            console.log('provider refresh')
            this.is_out_of_date = false
            if (this.$bus['_events']['init']) {
                this.$bus.$emit('init')
            } else {
                location.reload()
            }
        },
    },
}
</script>
<style scoped lang="scss">
    #breadcrumb {
        // & {
        //     padding: 0;
        // }
        // .ui.breadcrumb {
        //     display: inline;
        //     width: 100%;
        //     margin: 1em 1em;
        // }
    }
</style>
<style>
.out_of_date_alert[data-tooltip]:before, .out_of_date_alert[data-tooltip]:after {
    visibility: hidden;
}
.out_of_date_alert.active[data-tooltip]:before {
    -webkit-transform: rotate(45deg) scale(1)!important;
    transform: rotate(45deg) scale(1)!important;
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
}
.out_of_date_alert.active[data-tooltip]:after {
    display: block;
    -webkit-transform: translateX(-50%) scale(1)!important;
    transform: translateX(-50%) scale(1)!important;
    visibility: visible;
    pointer-events: auto;
}
.out_of_date_alert:after {
    color: #db2828!important;
}
</style>
